<template>
  <layout-main-inner
    v-loading="loading"
    title="标签使用记录">
    <layout-card-wrap hasSlot>
      <template slot="form">
        <room-select v-model="config.useRoomId" />
        <el-input
          v-model="config.tagNo"
          clearable=""
          style="margin-left: 10px;width: 200px;"
          placeholder="请输入标签序号"></el-input>

        <el-button
          style="margin-left: 10px;"
          type="primary"
          @click="handleCurrentChange(1)">刷新</el-button>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="标签序号"
          min-width="120"
          prop="formatedTagNo"></el-table-column>
        <el-table-column
          label="委托单号"
          width="180"
          prop="workOrderNum"></el-table-column>
        <el-table-column
          label="鉴定中心">
          <el-table-column
            label="拥有标签"
            min-width="160"
            prop="roomName"></el-table-column>
          <el-table-column
            label="使用标签"
            min-width="160"
            prop="useRoomName"></el-table-column>
        </el-table-column>
        <el-table-column
          label="使用时间"
          width="150">
          <template slot-scope="{ row }">{{ row.useTime | dateformat() }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import AppraiseLable from '../../../service/appraiseLable'
import RoomSelect from '../room-select.vue'
export default {
  name: 'LabelUsage',
  components: { RoomSelect },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, useRoomId: null, tagNo: '' }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    additem() {
      this.$refs.production.init()
    },
    allocationLabel(row) {
      const { beginTagNo: min, endTagNo: max, notAssignTagCount: maxAssignCount, tagSegId } = row
      this.$refs.allocation.init({ min, max, maxAssignCount }, { tagSegId })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      const { tagNo } = this.config
      AppraiseLable.getusedtags({ ...this.config, beginTagNo: tagNo, endTagNo: tagNo, tagNo: null })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
